<template>
  <v-navigation-drawer
    app
    fixed
    :stateless="$vuetify.breakpoint.lgAndUp"
    :value="$vuetify.breakpoint.lgAndUp || $store.state.navVisible"
    @input="$store.commit('setNavVisible', $event)"
    :width="collapsed ? 90 : ($vuetify.breakpoint.xs ? '100%' : '330')"
    class="left-navigation"
  >
    <div
      class="d-flex"
      style="height:100%;"
    >
      <v-navigation-drawer
        class="main-navigation"
        :width="90"
        stateless
        permanent
        :value="true"
        style="visibility: visible !important; transform: translateX(0) !important;"
        transition="slide-x-transition"
      >
        <div class="main-navigation-ordering">

          <a
            href="/"
            title="Home"
            class="rail-secondary"
          >
            <v-icon>fa-solid fa-house</v-icon>
          </a>

          <v-divider class="rail-divider" />

          <router-link
            :to="{ path: '/admin' }"
          >
            <v-icon>fa-solid fa-shield-halved</v-icon>
            <div class="main-navigation-text">Admin</div>
          </router-link>

        </div>
        <div
          slot="append"
          class="pb-4"
        >
          <v-divider class="rail-divider" />

          <a
            @click="toggleTheme"
            class="rail-secondary"
            style="cursor: pointer;"
          >
            <v-icon>{{ themeIcon }}</v-icon>
          </a>

          <a
            @click="dialog = true"
            class="rail-secondary"
            style="cursor: pointer;"
          >
            <v-icon>fa-solid fa-arrow-right-from-bracket</v-icon>
          </a>

        </div>
      </v-navigation-drawer>

      <div
        v-if="!collapsed"
        class="secondary-navigation text-body-2 flex-grow-1 fill-height"
      >
        <div
          v-for="(secondaryNavRoute,index) in secondaryNavRoutes"
          :key="secondaryNavRoute.name"
        >
          <div class="left-nav-ordering">
            <div v-if="index === 0">
              <div class="d-flex justify-space-between align-center">
                <div class="secondary-navigation-title font-weight-bold">{{secondaryNavRoute.meta.nav}}</div>
                <v-icon
                  v-if="$vuetify.breakpoint.mdAndDown"
                  class="cursor"
                  @click="$store.commit('setNavVisible', false)"
                >
                  fa-close
                </v-icon>
              </div>
            </div>

            <router-link
              :key="secondaryNavRoute.name"
              class="d-flex align-center pr-4"
              :to="{ name: secondaryNavRoute.name }"
            >
              <v-icon>{{ secondaryNavRoute.meta.icon }}</v-icon>
              {{ secondaryNavRoute.meta.name || secondaryNavRoute.name }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="dialog"
      width="400"
    >
      <v-card>
        <v-card-text class="pa-10 text-body-1">
          Are you sure you want to log out of your account?
        </v-card-text>
        <v-divider class="ma-0"></v-divider>
        <v-card-actions class="pa-6 justify-end">
          <v-btn large class="grey--text" plain @click="dialog = false">Cancel</v-btn>
          <v-btn
            large
            color="error"
            class="confirm"
            @click="logout"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-navigation-drawer>
</template>

<script>
import { routes } from '@/router'

export default {
  data () {
    return {
      dialog: false
    }
  },
  computed: {
    themeIcon () {
      return this.$vuetify.theme.dark ? 'fas fa-sun' : 'fas fa-moon'
    },
    collapse: {
      get () {
        return this.$store.state.navCollapse
      },
      set (value) {
        this.$store.commit('setNavCollapse', value)
      }
    },
    collapsed () {
      if (this.$vuetify.breakpoint.mdAndDown) {
        return false
      }
      if (
        this.$route.path === '/admin' ||
        this.$route?.meta?.navCollapse
      ) {
        return true
      }
      return this.$store.state.navCollapse
    },
    secondaryNavRoutes () {
      if (this.$route.meta?.nav === 'admin') {
        const secondaryNavRoutes = routes
          .filter(route => {
            return route?.meta?.nav === 'admin' &&
              !route?.redirect &&
              !route?.meta?.hidden &&
              (
                !route?.meta?.roles?.length ||
                route.meta.roles.reduce((acc, role) => acc || this.$hasRole(role), false)
              )
          })
          .map(route => {
            // Use the default child route's name as the name for the parent route to link to
            if (!route.name && route.children?.length) {
              route = {
                ...route,
                name: route.children.find(childRoute => !childRoute.path)?.name
              }
            }
            return route
          })

        return secondaryNavRoutes
      }
      return []
    }
  },
  methods: {
    async logout () {
      this.dialog = false
      try {
        document.body.style.opacity = 0.3
        await this.$store.dispatch('endSession')
      } finally {
        document.body.style.opacity = 1
      }
    },
    toggleTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      window.localStorage.setItem('darkMode', !!this.$vuetify.theme.dark)
    }
  }
}
</script>

<style lang="scss" scoped>
.left-navigation {
  background-color: #1A5984 !important;
  color: #fff;
  .main-navigation {
    width: 90px;
    margin: 0 auto;
    text-align: center;
    background-color: #1A5984;
    align-items: center;
    .v-navigation-drawer__border {
      display: none;
    }
    a {
      display: block;
      padding: 16px;
      width: 90px;
      text-decoration: none;
      color: #fff;
      opacity: 0.65;
      i,button {
        font-size: 2.1em;
        color: #fff;
      }
      &.router-link-active {
        opacity: 1 !important;
        i {
          color: #fff !important;
        }
      }
    }
    a:hover {
      opacity: 1;
    }
    .logo {
      background-color: unset;
      opacity: 1;
    }
    .main-navigation-text {
      margin-top: 0.6em;
      margin-bottom: 1em;
      font-size: 0.78em;
    }
    a.rail-secondary i {
      font-size: 1.5em;
    }
    .rail-divider.v-divider {
      border-color: rgba(255, 255, 255, 0.2);
      width: 56px;
      margin: 6px auto;
    }
  }
  .secondary-navigation {
    background-color: #fff;
    color: #000;
    padding-right: 16px;
    padding-left: 16px;
    width: 240px;
    a {
      display: block;
      padding: 11px 0px;
      margin-top: 4px;
      color: #000;
      text-decoration: none;
      font-size: 1em;
      i {
        font-size: 18px;
        color: #555;
        width: 52px;
        text-align: center;
      }
      > div {
        text-decoration: none;
        padding-left: 4px;
      }
      &.router-link-active {
        background-color: #f3f6f9;
        border-radius: 8px;
        font-weight: bold !important;
        i, div {
          font-weight: bold;
          color: #000;
        }
      }
      > .v-icon {
        font-size: 18px;
      }
      &:hover {
        background-color: #f3f6f9;
        border-radius: 8px;
      }
    }
    .secondary-navigation-title {
      color: #1A5984;
      font-weight: bold;
      text-transform: uppercase;
      padding: 24px 12px 17px 8px;
      border-bottom: 1px solid #e1e1e1;
      width: 100%;
    }
  }
}
.theme--dark .left-navigation {
  .main-navigation {
    background-color: #0a3855;
  }
  .secondary-navigation {
    background-color: #1e1e1e;
    color: #fff;
    a {
      color: #fff;
      &.router-link-active {
        background-color: #292929;
        i, div {
          color: #fff;
        }
      }
      &:hover {
        background-color: #292929;
      }
    }
    .secondary-navigation-title {
      color: #1A5984;
      border: none;
    }
  }
}
</style>
